import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import Poblacion from '../components/comuna/Poblacion';

const PoblacionContainer = () => (
  <div className='MainMunicipio'>
    <Poblacion />
  </div>
);
export default PoblacionContainer;
